import showToastr from './showToastr';


function showAutoSaveError () {
  showToastr('fa fa-exclamation-circle','There has been an error saving. You may have a connectivity problem.')
}

export default showAutoSaveError;